//GET_COMPANY_POLICY
export const GET_COMPANY_POLICY_REQUEST = "GET_COMPANY_POLICY_REQUEST";
export const GET_COMPANY_POLICY_SUCCESS = "GET_COMPANY_POLICY_SUCCESS";
export const GET_COMPANY_POLICY_FAIL = "GET_COMPANY_POLICY_FAIL";

//CREATE_COMPANY_POLICY
export const CREATE_COMPANY_POLICY_REQUEST = "CREATE_COMPANY_POLICY_REQUEST";
export const CREATE_COMPANY_POLICY_SUCCESS = "CREATE_COMPANY_POLICY_SUCCESS";
export const CREATE_COMPANY_POLICY_FAIL = "CREATE_COMPANY_POLICY_FAIL";

//UPDATE_COMPANY_POLICY
export const UPDATE_COMPANY_POLICY_REQUEST = "UPDATE_COMPANY_POLICY_REQUEST";
export const UPDATE_COMPANY_POLICY_SUCCESS = "UPDATE_COMPANY_POLICY_SUCCESS";
export const UPDATE_COMPANY_POLICY_FAIL = "UPDATE_COMPANY_POLICY_FAIL";

//DELETE_COMPANY_POLICY
export const DELETE_COMPANY_POLICY_REQUEST = "DELETE_COMPANY_POLICY_REQUEST";
export const DELETE_COMPANY_POLICY_SUCCESS = "DELETE_COMPANY_POLICY_SUCCESS";
export const DELETE_COMPANY_POLICY_FAIL = "DELETE_COMPANY_POLICY_FAIL";

//DELETE_COMPANY_POLICY_DOCUMENT
export const DELETE_COMPANY_POLICY_DOCUMENT_REQUEST =
  "DELETE_COMPANY_POLICY_DOCUMENT_REQUEST";
export const DELETE_COMPANY_POLICY_DOCUMENT_SUCCESS =
  "DELETE_COMPANY_POLICY_DOCUMENT_SUCCESS";
export const DELETE_COMPANY_POLICY_DOCUMENT_FAIL =
  "DELETE_COMPANY_POLICY_DOCUMENT_FAIL";
